import styled from "styled-components";

export const EarnContainer = styled.div`
  margin: 15px;
  min-height: 120vh;
`;

export const EarnTopCard = styled.div`
  display: flex;
  justify-content: space-between;
  margin-block: 5px;
`;

export const EarnTopCardButton = styled.button`
  display: flex;
  justify-content: space-evenly;
  border-radius: 15px;
  width: calc(100% - 10px);
  height: 35px;
  font-weight: bold;
  margin-inline: 5px;

  & > svg {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;

export const EarnCard = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #7b36ee;
  border-radius: 10px;
  padding: 10px 15px;
  margin-block: 50px 10px;
  background-color: ${({ theme }) => theme.colors.primary};
`;
